import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type BadgeVariant =
  | 'red'
  | 'amber'
  | 'blue'
  | 'purple'
  | 'gray'
  | 'teal'
  | 'pink'
  | 'green'
  | 'navy';

@Component({
  selector: 'tc-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.css',
})
export class BadgeComponent {
  label = input.required<string>();
  variant = input.required<BadgeVariant>();
}
